/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";
import { ReactComponent as Loader } from "../../loading.svg";

interface Props {
  text: string;
  onClick?: () => void | Promise<void>;
  className?: any;
  loading?: boolean;
  disabled?: boolean;
  name?: string;
  type?: any;
}

export const SubmitButton = ({ text = "Submit", className, onClick, loading, disabled, name = '', type }: Props): JSX.Element => {
  return (
    <button
      className={`submit-button ${className}`}
      {...{ disabled }}
      onClick={onClick}
      name={name}
      type={type}
    >
      {!loading ? text : '送出中'}
    </button>
  );
};

SubmitButton.propTypes = {
  text: PropTypes.string,
};
